<div class="screen">
  <div class="screen-inner">
    <app-shell nav="close" action="none" title="Edit player" [backTo]="backTo" [queryParams]="{ tab: 'players' }"></app-shell>

    @if (loaded) {
      <form class="form" (ngSubmit)="save()">
        <label class="field">
          <span class="field-label">First name</span>
          <input name="firstName" [(ngModel)]="firstName" />
          @if (fieldErrors['firstName']) { <span class="field-error">{{ fieldErrors['firstName'] }}</span> }
        </label>

        <label class="field">
          <span class="field-label">Last name</span>
          <input name="lastName" [(ngModel)]="lastName" />
          @if (fieldErrors['lastName']) { <span class="field-error">{{ fieldErrors['lastName'] }}</span> }
        </label>

        <label class="field">
          <span class="field-label">Display name</span>
          <input name="displayName" [(ngModel)]="displayName" />
          @if (fieldErrors['displayName']) {
            <span class="field-error">{{ fieldErrors['displayName'] }}</span>
          } @else {
            <span class="field-hint">This is the name on the leaderboard.</span>
          }
        </label>

        <label class="field">
          <span class="field-label">Handicap index</span>
          <input name="handicapIndex" inputmode="decimal" [(ngModel)]="handicapText" placeholder="10.4 or +1.4" />
          @if (fieldErrors['handicapIndex']) {
            <span class="field-error">{{ fieldErrors['handicapIndex'] }}</span>
          } @else {
            <span class="field-hint">Use 10.4 or +1.4. A plus index gives strokes back.</span>
          }
        </label>

        <button class="btn-primary" type="submit" [disabled]="saving">Save player</button>
      </form>

      <button class="btn-secondary btn-wide" type="button" (click)="copyAccountLink()">
        {{ hasLogin ? 'Copy password reset link' : 'Copy setup link' }}
      </button>
      @if (link) {
        <div class="card">
          <div class="row row-static">
            <span class="row-body">
              <span class="link-text">{{ link }}</span>
            </span>
          </div>
        </div>
        <p class="page-note">{{ copied ? 'Copied. ' : '' }}Send this outside the app. It expires in 3 days. A new link replaces the previous one.</p>
      }
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>
</div>
